import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectThread } from 'store/chat/services/getProjectThread.service';

export const loadThreadOnDemand = createAsyncThunk(
  'chat/loadThreadOnDemand',
  async ({ project }, { dispatch, getState }) => {
    const projectId = project.id;
    const state = getState().chatSlice;

    const threadInState = state.threadsByProject[projectId];
    if (threadInState) {
      return threadInState;
    }

    const thread = await getProjectThread(projectId);

    // Set thread in state
    const threadWithMetadata = {
      ...thread,
      parent: project.parent,
      children: [],
      unreadMessagesInChildProjects: 0,
    };

    return threadWithMetadata;
  }
);
